import styled from 'styled-components'
import { PROGRESS_AREA_HEIGHT } from '~/app/components/Header'
import {
  ANATOMY_COMPACT,
  anatomyCompact,
} from '~/pages/anatomy/libs/responsive'
import { anatomyRootCss } from '~/pages/anatomy/libs/styles'
import { Button } from '~/shared/components/Button'
import { Container } from '~/shared/components/Container'
import { COLORS } from '~/shared/constants/uiConstants'

export const ExpertsStyles = {
  Root: styled.div`
    ${anatomyRootCss}
  `,

  StyledContainer: styled(Container)`
    padding: 24px 16px;
    margin-top: ${PROGRESS_AREA_HEIGHT}px;
    height: calc(100% - ${PROGRESS_AREA_HEIGHT}px);
  `,

  Title: styled.h1`
    font-weight: 700;
    font-size: 22px;
    line-height: 24px;
    color: ${COLORS.BLACK};
    margin-bottom: 16px;

    ${anatomyCompact} {
      font-size: ${ANATOMY_COMPACT.fontSize.f22};
      line-height: ${ANATOMY_COMPACT.lineHeight.lh28};
    }
  `,

  Subtitle: styled.h2`
    font-size: 14px;
    line-height: 18px;
    color: ${COLORS.BLACK};
    margin-bottom: 32px;

    ${anatomyCompact} {
      margin-bottom: ${ANATOMY_COMPACT.spacing.s32};
    }
  `,

  University: styled.div`
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 12px 0;
    background: transparent;
    border: none;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
    border-radius: 0;

    &:not(:last-of-type) {
      margin-bottom: 0;
    }
  `,

  UniversityLogo: styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #f3f1ff;
    border: 1px solid #d7d6fb;
    height: 40px;
    width: 40px;
    color: ${COLORS.PURPLE_400};
    font-weight: 700;
    font-size: 13px;
    line-height: 16px;
    letter-spacing: 0.5px;
    border-radius: 12px;
  `,

  UniversityContent: styled.div`
    display: flex;
    flex-direction: column;
  `,

  UniversityDegree: styled.p`
    color: ${COLORS.GRAY_700};
    text-transform: uppercase;
    font-size: 8px;
    font-weight: 700;
    line-height: 12px;
  `,

  UniversityName: styled.p`
    font-weight: 700;
    font-size: 14px;
    line-height: 18px;
    color: ${COLORS.BLACK};
  `,

  UniversitiesWrapper: styled.div`
    margin-bottom: 16px;
  `,

  StyledButton: styled(Button)`
    margin-top: auto;
  `,
} as const
